export default __webpack_public_path__ + "static/media/juan.0a9762d7.png";